import { io } from "socket.io-client";
import configs from "configs";

export const socket = io(configs.appAPIBase);
